import React, { Component } from "react";

export default class Tour extends Component {

    state ={
        showInfo:false
    };
    displayInfo = () => {
        this.setState(
            {
                showInfo: !this.state.showInfo 
            }
        )
    }
  render() {
    const { id, city, img, name, info } = this.props.tour;
    const { removeTour } = this.props;
    console.log(this.props);

    return (
      <article className="tour_box">
          <span className="close_btn" onClick={() => removeTour(id)}>
              <i className="far fa-times-circle"></i>
          </span>
        <div className="img_holder">
          <img src={img} alt="tour img" />
        </div>
        <div className="info_holder">
          <h3>{city}</h3>
          <h3>{name}</h3>
          {/* <h3>info {" "}</h3>
          <span className="fas fa-caret-down"></span> */}
          <button onClick={this.displayInfo}> Show info {" "}<span className="fas fa-caret-down"></span></button>
          {this.state.showInfo && <p>{info}</p>}
          
        </div>
      </article>
    );
  }
}
